var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"side-menu-settings"},[_c('a',{attrs:{"href":_vm.href}},[_c('span',{staticClass:"avatardiv avatardiv-shown"},[_c('img',{attrs:{"src":_vm.avatar,"alt":_vm.label}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }